import React from "react";
import { useSimulationStore } from "../../store/simulationStore";
import { describeScale } from "../../utils/scaling";

export function StatusBar() {
  const precisionMode = useSimulationStore((s) => s.precisionMode);
  const direction = useSimulationStore((s) => s.direction);

  return (
    <footer className="tls-astro-statusbar">
      <span>
        {precisionMode === "kepler"
          ? "Kepler offline (aproximado)"
          : "Efemérides (com fallback Kepler)"}
      </span>
      <span>Direção: {direction === 1 ? "avançar" : "retroceder"}</span>
      <span>{describeScale()}</span>
    </footer>
  );
}
